import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';

import { legacyType } from '../../../styles/typography';

import PropTypes from 'prop-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getOptions } from '../textBlock/TextBlockWithIcon';

import MainCtaButton from '../button/MainCtaButton';
import { withRouteData } from 'react-static';

const Wrapper = styled.div`
  color: ${props => props.textColour};

  h2 {
    margin-bottom: var(--fr);
    font-size: ${props => props.headlineFontSize || 'var(--fs-xl)'};
  }
`;

const Body = styled.div`
  font-size: var(--fs-m);
  white-space: pre-line;
  ${legacyType('m', 'body')};

  a {
    text-decoration: underline;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: ${props => (props.fullWidth ? '100%' : 'auto')};

  & div:not(:last-child) {
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
`;

class TextBlock extends React.Component {
  constructor() {
    super();
    this.state = {
      body: null,
    };
  }

  componentDidMount() {
    const body = documentToReactComponents(
      this.props.content.body,
      getOptions(this.props.basename)
    );
    // eslint-disable-next-line
    this.setState({ body });
  }

  render() {
    const { content, centerText } = this.props;
    const { title, headline, ctaButton, textColour, headlineFontSize } = content;
    const { body } = this.state;

    return (
      <Wrapper
        textColour={textColour}
        className={centerText ? 'centerText' : 'defaultText'}
        headlineFontSize={headlineFontSize}
      >
        {headline && <h2>{headline}</h2>}
        {body && <Body>{body}</Body>}
        {ctaButton && (
          <ButtonWrapper fullWidth={ctaButton[0].fields.fullWidth}>
            {ctaButton.map((btn, index) => {
              if (get(btn, 'fields')) {
                const buttonTitle = btn.fields.title;
                return (
                  <MainCtaButton
                    key={index}
                    content={btn.fields}
                    invertColour={textColour === 'Black'}
                    trackingData={{
                      title: buttonTitle,
                      from: `Hero Block - ${title}`,
                    }}
                  />
                );
              }
              return null;
            })}
          </ButtonWrapper>
        )}
      </Wrapper>
    );
  }
}

TextBlock.propTypes = {
  content: PropTypes.object,
  centerText: PropTypes.bool,
  basename: PropTypes.string.isRequired,
};

export default withRouteData(TextBlock);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/heroBlock/TextBlock.js